// API URL definida automaticamente no index.html via window.API_URL
export let apiUrl = (typeof window !== 'undefined' && window.API_URL) 
  ? window.API_URL 
  : 'https://404dash-backend.404hub.net'; // Fallback para produção

// CÓDIGO ANTIGO (mantido para referência):
//export let apiUrl = 'http://localhost:3001';//LOCAL
//export let apiUrl = 'https://404dash-backend.404hub.net';//PRODUÇÃO NOVO
//export let apiToken = "x]qu=G4JnTlDDbDzG$`h0m?,@T ?[Q8-";

export default apiUrl; 